import component from "containers/StaticPages/pages/AmbassadorSignup";

export default {
  key: "ambassador-signup",
  title: "Ambassador Signup",
  path: "/:user?/ambassador/signup",
  pageName: "ambassadorSignup",
  linkTarget: "/ambassador/signup",
  exact: true,
  component,
};
